import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from '../../AutopilotPlansModal.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ArrowLeft } from 'blaze-ui/icons'

import { SelectedPlanForm } from './components/SelectedPlanForm/SelectedPlanForm'
import { AutopilotPlan, StripePrice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'
import { OnStartPlan } from '../../AutopilotPlansModal'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const Form = ({
  onBack,
  selectedPlan,
  onStartPlan,
  currentPrice,
  shouldAutoReloadCredits,
  toggleAutoReloadCredits,
}: {
  onBack: () => void
  onStartPlan: OnStartPlan
  selectedPlan: AutopilotPlan
  currentPrice: StripePrice | null
  shouldAutoReloadCredits: boolean
  toggleAutoReloadCredits: () => void
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  return (
    <>
      <Modal.Header>
        <div className={Styles.header}>
          <div className={Styles.left}>
            <IconButton icon={ArrowLeft} onPress={onBack} variant="tertiary" size="xs" />
            <Heading level={3}>Choose your plan length</Heading>
          </div>
        </div>
      </Modal.Header>
      <Modal.Content withoutFooter={isSystemRedesignEnabled}>
        <SelectedPlanForm
          selectedPlan={selectedPlan}
          currentPrice={currentPrice}
          onBack={onBack}
          onStartPlan={onStartPlan}
          shouldAutoReloadCredits={shouldAutoReloadCredits}
          toggleAutoReloadCredits={toggleAutoReloadCredits}
        />
      </Modal.Content>
    </>
  )
}
